import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import {
  submitAddServiceRequestComment,
  submitResolveServiceRequest,
  submitUpdateServiceRequest
} from '~/api/data/servicing/mutations';
import { loadServiceRequest, loadServiceRequests } from '~/api/data/servicing/queries';
import { loadAgencyUsers } from '~/api/data/users/queries';
import {
  ServiceRequestCommentsAndActivityPage,
  ServiceRequestConversationPage,
  ServiceRequestOverviewPage,
  ServiceRequestPage,
  ServicingPage
} from '~/pages/servicing/servicing';

export const servicingRoutes: RouteObject[] = [
  {
    path: 'servicing',
    loader: merge({
      serviceRequests: loadServiceRequests
    }),
    element: <ServicingPage />
  },
  {
    id: 'servicing/:id',
    path: 'servicing/:id',
    loader: merge({
      serviceRequest: loadServiceRequest,
      agencyUsers: loadAgencyUsers
    }),
    element: <ServiceRequestPage />,
    children: [
      {
        index: true,
        element: <ServiceRequestOverviewPage />
      },
      {
        path: 'resolve',
        action: byMethod({
          POST: submitResolveServiceRequest
        }),
        element: <Navigate to="../overview" replace />
      },
      {
        path: 'update',
        action: byMethod({
          POST: submitUpdateServiceRequest
        }),
        element: <Navigate to="../overview" replace />
      },
      {
        path: 'overview',
        element: <ServiceRequestOverviewPage />
      },
      {
        path: 'conversation',
        element: <ServiceRequestConversationPage />
      },
      {
        path: 'activity',
        element: <ServiceRequestCommentsAndActivityPage />,
        children: [
          {
            path: 'comment',
            action: byMethod({
              POST: submitAddServiceRequestComment
            }),
            element: <Navigate to="../activity" replace />
          }
        ]
      }
    ]
  }
];
